import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-177e7912"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "streak-show" }
const _hoisted_2 = { class: "streak-show__main" }
const _hoisted_3 = { class: "streak-show__header" }
const _hoisted_4 = {
  key: 0,
  class: "streak-show__title"
}
const _hoisted_5 = { class: "streak-show__title-text" }
const _hoisted_6 = {
  key: 1,
  class: "streak-show__title streak-show__title--loading"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "streak-show__title-text" }, " Streak: ", -1))
const _hoisted_8 = { class: "streak-show__stats" }
const _hoisted_9 = { class: "streak-show__stat-content" }
const _hoisted_10 = { class: "streak-show__stat-icon" }
const _hoisted_11 = { class: "streak-show__stat-info" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "streak-show__stat-label" }, "Current Streak", -1))
const _hoisted_13 = { class: "streak-show__stat-value" }
const _hoisted_14 = { class: "streak-show__stat-content" }
const _hoisted_15 = { class: "streak-show__stat-icon" }
const _hoisted_16 = { class: "streak-show__stat-info" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "streak-show__stat-label" }, "Longest Streak", -1))
const _hoisted_18 = { class: "streak-show__stat-value" }
const _hoisted_19 = { class: "streak-show__stat-content" }
const _hoisted_20 = { class: "streak-show__stat-icon" }
const _hoisted_21 = { class: "streak-show__stat-info" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "streak-show__stat-label" }, "Active Days", -1))
const _hoisted_23 = { class: "streak-show__stat-value" }
const _hoisted_24 = { class: "streak-show__stat-content" }
const _hoisted_25 = { class: "streak-show__stat-icon" }
const _hoisted_26 = { class: "streak-show__stat-info" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "streak-show__stat-label" }, "Avg Focus Time", -1))
const _hoisted_28 = { class: "streak-show__stat-value" }
const _hoisted_29 = {
  key: 0,
  class: "streak-show__pagination"
}
const _hoisted_30 = { class: "streak-show__pagination-info" }
const _hoisted_31 = { class: "streak-show__calendar" }
const _hoisted_32 = {
  key: 0,
  class: "streak-show__sidebar"
}
const _hoisted_33 = { class: "streak-show__date-badge" }
const _hoisted_34 = { class: "streak-show__sidebar-section" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "streak-show__sidebar-title" }, " Tasks of day ", -1))
const _hoisted_36 = { class: "streak-show__tasks" }
const _hoisted_37 = {
  key: 2,
  class: "streak-show__empty"
}
const _hoisted_38 = { class: "streak-show__sidebar-section" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "streak-show__sidebar-title" }, " Projects worked in day ", -1))
const _hoisted_40 = { class: "streak-show__badges" }
const _hoisted_41 = {
  key: 2,
  class: "streak-show__empty"
}

import { useRoute } from 'vue-router';
import { computed, ref, watch } from 'vue';
import { groupBy } from 'lodash';

import DayStreakModal from './DayStreakModal.vue';
import { DateSkeleton } from '@/design-system/Skeleton';
import DSCard from '@/design-system/DSCard.vue';
import DSButton from '@/design-system/DSButton.vue';
import DSBadge from '@/design-system/DSBadge.vue';

import { useStore } from '@/store';
import { FETCH_STREAK, FETCH_STREAK_FOCUS_SUMMARIES } from '@/store/types/actions';
import FocusSummary from '@/interfaces/FocusSummary.interface';


export default /*#__PURE__*/_defineComponent({
  __name: 'DCStreak',
  setup(__props) {

const store = useStore();
const route = useRoute();

const dayStreakModal = ref(DayStreakModal);
const { streak_id } = route.params;

const request_pending = computed(() => {
  const { streak: streak_request_pending = {} } = store.state.requests_pending;
  return streak_request_pending.show || streak_request_pending.focus_summaries;
});

const openDayStreakModal = (params: { selected_date: string, focused_summary: FocusSummary }) => {
  dayStreakModal.value.openModal(params);
};

const getFocusTimeForDate = (date: string): number | null => {
  const summary = focus_summaries.value.find(s => {
    const [year, month, day] = s.date.split('-').map(d => parseInt(d, 10));
    const summary_date = new Date(year, month, day).getTime();
    const [y, m, d] = date.split('/').map(d => parseInt(d, 10));
    const target_date = new Date(y, m - 1, d).getTime();

    return Math.abs(summary_date - target_date) < 86400001;
  });

  return summary ? summary.totalFocusTime : null;
};

const getDayStyle = (date: string) => {
  const focus_time = getFocusTimeForDate(date);
  if (!focus_time) return {};

  const level = getActivityLevel(focus_time);
  const colors = [
    'var(--text-tertiary)',
    'var(--success-light)',
    'var(--success)',
    'var(--info)',
    'var(--primary)',
  ];

  return {
    color: colors[level],
  };
};

store.dispatch(FETCH_STREAK, streak_id);
store.dispatch(FETCH_STREAK_FOCUS_SUMMARIES, streak_id);

const focus_summaries = computed(() => store.state.streak.focus_summaries);
const streak = computed(() => store.state.streak.streak);

const days_for_get_days = ref({} as { [key: string]: string });
const getDays = computed(() => {
  getVisibleDateLabels.value.forEach(value => Object.assign(days_for_get_days.value, { [value]: getDaysLabels(value) }));
  return days_for_get_days.value;
});

const pagination_offset = ref(0);

watch(pagination_offset, () => {
  days_for_get_days.value = {};
});

const getDaysLabels = (month_label: string) => {
  if (getDaysByMonths.value[month_label]) {
    return getDaysByMonths.value[month_label].map((summary) => {
      const date = getDateFromSummary(summary.date);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');

      return `${year}/${month}/${day}`;
    });
  }

  return [];
};

const getDaysByMonths = computed(() => {
  const aggregate_by_months = groupBy(focus_summaries.value, (summary) => {
    const date = getDateFromSummary(summary.date);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');

    return `${year}/${month}`;
  });

  return aggregate_by_months;
});

const getDateFromSummary = (date: string) => {
  const [year, month, day] = date.split('-').map(date_string => +date_string);
  return new Date(year, month, day);
};

const getDateLabels = computed(() => {
  if (focus_summaries.value.length) {
    const first_focus_summary = focus_summaries.value[focus_summaries.value.length - 1];
    const last_focus_summary = focus_summaries.value[0];

    const first_month_date = getDateFromSummary(first_focus_summary.date);
    const last_month_date = getDateFromSummary(last_focus_summary.date);

    let months = (last_month_date.getFullYear() - first_month_date.getFullYear()) * 12;
    months -= first_month_date.getMonth();
    months += last_month_date.getMonth();

    const total_months = months + 1;
    const month_labels = getMonthsByYearLabels(total_months, first_month_date);

    return month_labels.reverse();
  }

  return [];
});

const total_months = computed(() => {
  return getDateLabels.value.length;
});

const getVisibleDateLabels = computed(() => {
  return getDateLabels.value.slice(pagination_offset.value, pagination_offset.value + 6);
});

const getMonthsByYearLabels = (months: number, first_month_date: Date) => {
  const newArray = new Array(months).fill(null);

  const months_years_labels = newArray.map((_, index) => {
    const label_date = new Date(first_month_date.getFullYear(), first_month_date.getMonth() + index);
    return `${label_date.getFullYear()}/${(label_date.getMonth() + 1).toString().padStart(2, '0')}`;
  });

  return months_years_labels;
};

const current_date = new Date();
const selected_date = ref(`${current_date.getFullYear()}-${current_date.getMonth()}-${current_date.getDate()}`);

const getFormattedDate = computed(() => {
  if (selected_date.value) {
    let [year, month, date] = selected_date.value.split('-');
    month = (+month + 1).toString().padStart(2, '0');
    date = date.padStart(2, '0');
    return `${date}/${month}/${year}`;
  }

  return `${current_date.getDate()}/${current_date.getMonth() + 1}/${current_date.getFullYear()}`;
});

const handleUpdate = (value: string[], reason: string, details: { year: number, month: number, day: number }) => {
  getDateLabels.value.forEach(value => Object.assign(days_for_get_days.value, { [value]: getDaysLabels(value) }));

  if (reason === 'remove-day') {
    let { year, month, day } = details;
    selected_date.value = `${year}-${month - 1}-${day}`;
    openDayStreakModal({ selected_date: selected_date.value, focused_summary: getSelectedFocusSummary.value });
    return false;
  }
};

const getSelectedFocusSummary = computed(() => {
  const focused_selected_date = focus_summaries.value.find(summary => summary.date === selected_date.value);

  if (focused_selected_date) {
    return focused_selected_date;
  }

  return {
    date: '',
    totalFocusTime: 0,
    totalFucusedSessions: 0,
    totalTasks: 0,
    totalProjects: 0,
    tasks: [],
    projects: [],
  } as FocusSummary;
});

const getCurrentStreak = computed(() => {
  if (!focus_summaries.value.length) return 0;

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  let streak = 0;
  let check_date = today.getTime() - 86400000;

  for (let i = 0; i < focus_summaries.value.length; i++) {
    const summary_date = getDateFromSummary(focus_summaries.value[i].date).getTime();

    if (Math.abs(summary_date - check_date) < 86400001) {
      streak++;
      check_date -= 86400000;
    } else {
      break;
    }
  }

  return streak;
});

const getLongestStreak = computed(() => {
  if (!focus_summaries.value.length) return 0;

  let max_streak = 0;
  let current_streak = 0;
  let check_date = null;

  for (let i = focus_summaries.value.length - 1; i >= 0; i--) {
    const summary = focus_summaries.value[i];
    const summary_date = getDateFromSummary(summary.date).getTime();

    if (summary.totalFocusTime > 0) {
      if (check_date === null) {
        check_date = summary_date;
        current_streak = 1;
      } else if (Math.abs(summary_date - check_date) < 86401000) {
        current_streak++;
        check_date = summary_date;
      } else {
        max_streak = Math.max(max_streak, current_streak);
        current_streak = 1;
        check_date = summary_date;
      }
    } else {
      max_streak = Math.max(max_streak, current_streak);
      current_streak = 0;
      check_date = null;
    }
  }

  max_streak = Math.max(max_streak, current_streak);

  return max_streak;
});

const getTotalActiveDays = computed(() => {
  return focus_summaries.value.filter(summary => summary.totalFocusTime > 0).length;
});

const getAverageFocusTime = computed(() => {
  const active_summaries = focus_summaries.value.filter(summary => summary.totalFocusTime > 0);
  if (!active_summaries.length) return '0h 0m';

  const total_seconds = active_summaries.reduce((sum, summary) => sum + summary.totalFocusTime, 0);
  const average_seconds = total_seconds / active_summaries.length;

  const hours = Math.floor(average_seconds / 3600);
  const minutes = Math.floor((average_seconds % 3600) / 60);

  return `${hours}h ${minutes}m`;
});

const getActivityLevel = (focusTime: number): number => {
  const active_summaries = focus_summaries.value.filter(summary => summary.totalFocusTime > 0);
  if (!active_summaries.length) return 0;

  const focus_times = active_summaries.map(s => s.totalFocusTime).sort((a, b) => a - b);
  const p25 = focus_times[Math.floor(focus_times.length * 0.25)] || 0;
  const p50 = focus_times[Math.floor(focus_times.length * 0.5)] || 0;
  const p75 = focus_times[Math.floor(focus_times.length * 0.75)] || 0;

  if (focusTime >= p75) return 4;
  if (focusTime >= p50) return 3;
  if (focusTime >= p25) return 2;
  if (focusTime > 0) return 1;
  return 0;
};

return (_ctx: any,_cache: any) => {
  const _component_q_skeleton = _resolveComponent("q-skeleton")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_date = _resolveComponent("q-date")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("main", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(DSButton, {
          icon: "arrow_back",
          variant: "ghost",
          label: "Back to Streaks",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/streaks')))
        }),
        (! request_pending.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("h2", _hoisted_5, " Streak: " + _toDisplayString(streak.value.name), 1)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_q_skeleton, {
                type: "text",
                width: "200px",
                height: "30px"
              })
            ]))
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(DSCard, { class: "streak-show__stat-card" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_q_icon, {
                  name: "local_fire_department",
                  size: "32px",
                  color: "warning"
                })
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("span", _hoisted_13, _toDisplayString(getCurrentStreak.value) + " days", 1)
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(DSCard, { class: "streak-show__stat-card" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_q_icon, {
                  name: "emoji_events",
                  size: "32px",
                  color: "warning"
                })
              ]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("span", _hoisted_18, _toDisplayString(getLongestStreak.value) + " days", 1)
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(DSCard, { class: "streak-show__stat-card" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_q_icon, {
                  name: "calendar_today",
                  size: "32px",
                  color: "primary"
                })
              ]),
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("span", _hoisted_23, _toDisplayString(getTotalActiveDays.value) + " / " + _toDisplayString(focus_summaries.value.length), 1)
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(DSCard, { class: "streak-show__stat-card" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createVNode(_component_q_icon, {
                  name: "schedule",
                  size: "32px",
                  color: "info"
                })
              ]),
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _createElementVNode("span", _hoisted_28, _toDisplayString(getAverageFocusTime.value), 1)
              ])
            ])
          ]),
          _: 1
        })
      ]),
      (total_months.value > 6)
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
            _createVNode(DSButton, {
              variant: "ghost",
              icon: "chevron_left",
              disabled: pagination_offset.value <= 0,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (pagination_offset.value = Math.max(0, pagination_offset.value - 6)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Previous 6 Months ")
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createElementVNode("span", _hoisted_30, " Displaying " + _toDisplayString(Math.min(total_months.value, pagination_offset.value + 1)) + "-" + _toDisplayString(Math.min(total_months.value, pagination_offset.value + 6)) + " of " + _toDisplayString(total_months.value) + " months ", 1),
            _createVNode(DSButton, {
              variant: "ghost",
              icon: "chevron_right",
              disabled: pagination_offset.value + 6 >= total_months.value,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (pagination_offset.value = Math.min(total_months.value - 6, pagination_offset.value + 6)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Next 6 Months ")
              ]),
              _: 1
            }, 8, ["disabled"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_31, [
        (request_pending.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(3, (n) => {
              return _createVNode(_unref(DateSkeleton), {
                key: n,
                class: "streak-show__skeleton"
              })
            }), 64))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(getVisibleDateLabels.value, (month_label) => {
              return (_openBlock(), _createElementBlock("div", {
                key: month_label,
                class: "streak-show__calendar-month"
              }, [
                _createVNode(_component_q_date, {
                  modelValue: getDays.value[month_label],
                  "onUpdate:modelValue": [($event: any) => ((getDays.value[month_label]) = $event), handleUpdate],
                  class: "no-shadow",
                  multiple: "",
                  "today-btn": "",
                  minimal: "",
                  dense: "",
                  bordered: "",
                  "years-in-month-view": false,
                  "default-year-month": month_label,
                  "navigation-min-year-month": month_label,
                  "navigation-max-year-month": month_label,
                  color: "primary",
                  onClick: handleUpdate
                }, {
                  day: _withCtx(({ date }) => [
                    (getFocusTimeForDate(date))
                      ? (_openBlock(), _createBlock(_component_q_icon, {
                          key: 0,
                          name: "fiber_manual_record",
                          style: _normalizeStyle(getDayStyle(date)),
                          size: "10px"
                        }, null, 8, ["style"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue", "default-year-month", "navigation-min-year-month", "navigation-max-year-month"])
              ]))
            }), 128))
      ])
    ]),
    (_ctx.$q.screen.gt.xs)
      ? (_openBlock(), _createElementBlock("aside", _hoisted_32, [
          _createVNode(DSCard, { class: "streak-show__sidebar-card" }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("span", null, "Day: " + _toDisplayString(getFormattedDate.value), 1)
              ])
            ]),
            content: _withCtx(() => [
              _createElementVNode("div", _hoisted_34, [
                _hoisted_35,
                _createElementVNode("div", _hoisted_36, [
                  (request_pending.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(3, (n) => {
                        return _createVNode(_component_q_skeleton, {
                          key: n,
                          type: "text",
                          width: "100%",
                          height: "30px"
                        })
                      }), 64))
                    : (getSelectedFocusSummary.value.tasks.length)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(getSelectedFocusSummary.value.tasks, (task) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: task.id,
                            class: "streak-show__task"
                          }, [
                            _createElementVNode("span", null, _toDisplayString(task.description), 1)
                          ]))
                        }), 128))
                      : (_openBlock(), _createElementBlock("span", _hoisted_37, "Not found tasks for this day"))
                ])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _hoisted_39,
                _createElementVNode("div", _hoisted_40, [
                  (request_pending.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(3, (n) => {
                        return _createVNode(_component_q_skeleton, {
                          key: n,
                          type: "text",
                          width: "90px",
                          height: "30px"
                        })
                      }), 64))
                    : (getSelectedFocusSummary.value.projects.length)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(getSelectedFocusSummary.value.projects, (project) => {
                          return (_openBlock(), _createBlock(DSBadge, {
                            key: project.name,
                            label: project.name,
                            variant: "secondary"
                          }, null, 8, ["label"]))
                        }), 128))
                      : (_openBlock(), _createElementBlock("span", _hoisted_41, "Not found projects for this day"))
                ])
              ])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(DayStreakModal, {
      ref_key: "dayStreakModal",
      ref: dayStreakModal
    }, null, 512)
  ]))
}
}

})